import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Dummy from "../../assets/images/No_Image_Available.jpg";

const DatatableTables = ({ t }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Title"),
        field: "title",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Video"),
        field: "video",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Activities"),
        field: "activities",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Frequency"),
        field: "frequency",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Occupation"),
        field: "occupation",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Exercise Type"),
        field: "exercise_type",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Action"),
        field: "edit",
        sort: "asc",
        width: 120,
      },
    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const getExercisesData = async (page) => {
    try {
      const exercisesData = await get(`exercise/exercises-videos/?page=${page}&page_size=10`);
      setTotalPages(exercisesData.total_pages); // Adjust based on API response

      // Mapping API response to fit the table rows
      const modifiedRows = exercisesData.results.map(exercise => ({
        id: exercise.id,
        title: exercise.title,
        video: (
          <a href={exercise.video} target="_blank" rel="noopener noreferrer">
            {t("Watch Video")}
          </a>
        ),
        activities: exercise.activities.join(", "),
        frequency: exercise.frequency,
        occupation: exercise.occupation.join(", "),
        exercise_type: exercise.exercise_id.exercise_name,
        edit: <Button color="primary" onClick={() => handleEdit(exercise.id)}>{t("Edit")}</Button>,
      }));

      // Updating the state with modified rows
      setData(prevState => ({
        ...prevState,
        rows: modifiedRows
      }));
    } catch (error) {
      console.error('Error fetching exercise data:', error);
    }
  };

  useEffect(() => {
    getExercisesData(currentPage);
  }, [currentPage]);

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleButtonClick = () => {
    const selectedIds = selectedRows;
    console.log("Selected IDs:", selectedIds);
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (id) => {
    navigate(`/category/edit-video/id/id/${id}`);
    console.log("Edit button clicked for exercise with ID:", id);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Exercises Videos")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle className="h4">{t("exercisevidlist")}</CardTitle>
                  <Button color="primary" onClick={() =>  navigate(`/category/add-video/id/id/${"id"}`)}>
                    <i className="typcn typcn-plus"></i> {t("Add Video")}
                  </Button>
                  </div>


                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging={false}
                    data={{
                      columns: data.columns,
                      rows: data.rows
                    }}
                    className="custom-cursor-pointer"
                  />



                  <MDBPagination className='mt-3'>
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>
                        {t("Previous")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                          {page + 1}
                        </MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>
                        {t("Next")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
